import { Component } from '@angular/core';

@Component({
    selector: 'brover-start',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class BroverComponent {
}
